<template lang="pug">
el-menu.navbar(mode='horizontal')
  breadcrumb.breadcrumb-container
</template>

<script>
import Breadcrumb from '@/components/Element/Breadcrumb'
export default {
  name: 'BaseLayoutTheNavbar',
  components: {
    Breadcrumb
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Base/Layout/TheNavbar/index.vue